(() => {
  const popup = document.querySelector('[data-nd-added]');
  if (!popup) return;

  const money = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return `$${amount}`;
  };

  const closeDrawer = () => {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    if (typeof drawer.close === 'function') drawer.close();
    drawer.removeAttribute('open');
  };

  const fill = (item) => {
    if (!item) return;
    const qty = Number(item.quantity) || 1;
    const status = popup.querySelector('[data-nd-added-status]');
    const name = popup.querySelector('[data-nd-added-name]');
    const price = popup.querySelector('[data-nd-added-price]');
    const qtyEl = popup.querySelector('[data-nd-added-qty]');
    const image = popup.querySelector('[data-nd-added-image]');
    if (status) status.textContent = qty === 1 ? '1 item added to cart' : `${qty} items added to cart`;
    if (name) name.textContent = item.product_title || item.title || '';
    if (price) price.textContent = typeof item.price === 'number' ? money(item.final_price || item.price) : item.price || '';
    if (qtyEl) qtyEl.textContent = String(qty);
    if (image) {
      if (item.image) {
        image.src = item.image;
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.hidden = true;
      }
    }
  };

  const place = () => {
    const dialog = popup.querySelector('.nd-added__dialog');
    const caret = popup.querySelector('[data-nd-added-caret]');
    const pin = popup.querySelector('[data-nd-added-pin]');
    const trigger = document.querySelector('[data-cart-popup-trigger]');
    if (!dialog) return;
    const width = Math.min(423, window.innerWidth - 32);
    const margin = 16;
    let left = Math.max(margin, (window.innerWidth - width) / 2);
    let top = Math.max(margin, (window.innerHeight - 384) / 2);
    if (trigger) {
      const icon = trigger.getBoundingClientRect();
      const iconCenter = icon.left + icon.width / 2;
      left = iconCenter - width / 2;
      left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));
      top = Math.max(margin, icon.bottom + 14);
      if (caret) caret.style.left = `${iconCenter - left}px`;
      if (pin) {
        const source = trigger.querySelector('.header-actions__cart-icon') || trigger;
        pin.innerHTML = source.innerHTML;
        const size = Math.max(icon.width, icon.height) + 8;
        pin.hidden = false;
        pin.style.width = `${size}px`;
        pin.style.height = `${size}px`;
        pin.style.top = `${icon.top + icon.height / 2 - size / 2}px`;
        pin.style.left = `${icon.left + icon.width / 2 - size / 2}px`;
      }
    } else if (pin) {
      pin.hidden = true;
    }
    dialog.style.top = `${top}px`;
    dialog.style.left = `${left}px`;
  };

  const open = (item) => {
    closeDrawer();
    if (item) fill(item);
    popup.hidden = false;
    document.documentElement.classList.add('nd-added-open');
    place();
  };

  const close = () => {
    popup.hidden = true;
    document.documentElement.classList.remove('nd-added-open');
  };

  const openFromCart = async () => {
    closeDrawer();
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((response) => response.json());
      const item = cart.items && cart.items[0];
      if (!item) {
        window.location.href = '/cart';
        return;
      }
      open({
        product_title: item.product_title,
        image: item.image,
        price: item.final_price,
        quantity: item.quantity,
      });
    } catch (error) {
      console.warn('[added-popup] cart load failed', error);
      window.location.href = '/cart';
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('[data-cart-popup-trigger]') : null;
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      openFromCart();
    },
    true
  );

  popup.querySelectorAll('[data-nd-added-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) close();
  });

  document.addEventListener('nd:added-popup', (event) => {
    open(event.detail || null);
  });

  window.addEventListener('resize', () => {
    if (!popup.hidden) place();
  });
})();
